
$('[data-background], img[data-src]').imageLoader();

$(function() {
    $('[data-background], img[data-src]').imageLoader();

	$('.form-custom-range').customRange();

    // Open popup links inside a modal
	$(document).on('click', 'a.popup', function(e) {
		e.preventDefault();
		window.top.openIframePopup($(this).attr('href'));
	});

	// Make sure internal links inside popups are opened correctly
	$('body.popup .text a[href^="/"]').addClass('popup');

	// Make sure external links inside popups are opened in a new window
	$('body.popup a[href^="http"]').attr('target', '_blank');

	// Smooth scroll to anchors
	$('a[href^="#"]:not([data-bs-dismiss], [data-bs-toggle], .noscroll)').on('click', function(e) {
		var id = $(this).attr('href').substring(1);
		var $element = $('[id="' + id + '"], [name="' + id + '"]').first();

		if (id !== '' && $element.length > 0) {
			e.preventDefault();
			smoothScrollTo($element);
			document.location.hash = id;
		}
	});

	// Copy text button
	$('.copy-text').on('click', function(e) {
		e.preventDefault();

		if (!navigator.clipboard.writeText) {
			return false;
		}

		console.log('copy', $($(this).data('target')).text());

		navigator.clipboard.writeText($($(this).data('target')).text()).then(() => {
			$(this).addClass('success');
		},() => {
			$(this).addClass('failed');
		});

		setTimeout(() => {
			$(this).removeClass('success').removeClass('failed');
		}, 2000);

		return true;
	});

	$('body').tooltip({
		selector: '[data-bs-toggle="tooltip-click"]',
		trigger: 'click',
		offset: "0,20",
	});

	$('#main').tooltip({
		selector: '[data-bs-toggle="tooltip"]',
		offset: "0,20",
	});

	$('.toggle-text-size').on('click', function(e) {
		e.preventDefault();

		var $html = $('html');
		var size  = $html.attr('data-text-size');

		// if (size === 'md') size = 'lg';
		// else if (size === 'lg') size = 'sm';
		// else size = 'md';

		if (size === 'lg') size = 'sm';
		else size = 'lg';

		$.get('/site/ajax/set_text_size.php?size=' +  size);
		$html.attr('data-text-size', size);
	});

	$('.speak').on('click',function(){
		if ( $('#read-stop').hasClass('d-none') ) {
			$('#read-stop').removeClass('d-none');
			$('#read-start').addClass('d-none');
			$('.rsbtn_text').trigger("click");
		} else {
			$('#read-stop').addClass('d-none');
			$('#read-start').removeClass('d-none');
			$('.rsbtn_stop').trigger("click");
		}
	});

	$(document).on('click', '.confirm', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		showConfirm({
			text:      $(this).data('confirm'),
			textYes:   $(this).data('text-yes'),
			textNo:    $(this).data('text-no'),
			urlYes:    $(this).attr('href'),
			onConfirm: $(this).data('onconfirm'),
		});
	});

	$(document).on('click', '.show-alert', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		//showAlert($(this).data('alert'));
		showAlert({
			text:      	 $(this).data('alert'),
			textHeader:  $(this).data('header'),
			textButton:  $(this).data('btn-text'),
		});
	});

    $('input[type=number]').on('input', function() {
        var min       = parseInt($(this).attr('min'));
        var max       = parseInt($(this).attr('max'));
		var maxLength = parseInt($(this).attr('maxlength'));
        var value     = parseInt($(this).val());

        if (!isNaN(max) && value > max) {
            $(this).val(max);
        }

        if (!isNaN(min) && value < min) {
            $(this).val(min);
        }

		if (!isNaN(maxLength)) {
			$(this).val($(this).val().substring(0, maxLength));
		}
    });

	$(document).on('click', '.btn', function(e) {
		var $btn = $(this);
		$btn.addClass('clicked');

		setTimeout(function() {
			$btn.removeClass('clicked');
		}, 100);
	});

	$('.next-body-template').on('click', function(e) {
		e.preventDefault();
		smoothScrollTo($(this).closest('.body-template').next('.body-template'), 0, 1000);
	});

	$('.toggle-pass').on('mousedown', function(e) {
		e.preventDefault();

		var $passField = $(this).parent().find('input');
		var $icon      = $(this).find('i');
		var newType    = $passField.attr('type') === 'text' ? 'password' : 'text';

		$passField.attr('type', newType).focus();
		newType === 'text' ? $icon.addClass('fa-eye-slash') : $icon.removeClass('fa-eye-slash');
	}).on('click', function(e) {
		e.preventDefault();
	});

   	$('.modal').on('show.bs.modal', function(e) {
   		$('body').addClass('modal-active').css('margin-right', getScrollbarWidth());
   	}).on('hide.bs.modal', function(e) {
   		$('body').removeClass('modal-active').css('margin-right', 0);
   	});

	$('select').on('change empty-init', function() {
		$(this).toggleClass('empty', $(this).val() === '');
	}).trigger('empty-init');

	// scroll to top icon
	$(window).scroll(function() {
		//if ($('.page-template').hasClass('sub_bodies')) {
			if ($(this).scrollTop() > 1000) {
				$('#scroll-to-top').fadeIn();
			} else {
				$('#scroll-to-top').fadeOut();
			}
		//}
	});

	$('#scroll-to-top').on('click', function() {
		$("html, body").animate({
			scrollTop: 0
		}, 600);
		return false;
	});

	$('#search-field .form-control').on('click', function(e){
		e.stopPropagation();
		$('.most-searched').slideDown();
	});

	$(document).on('click', function(e) {
		var suggestionsDropdownSelector = '.most-searched'

		if ($(e.target).closest(suggestionsDropdownSelector).length > 0) {
			return;
		}

		$(suggestionsDropdownSelector).slideUp();
	});

});

$(window).on('resize resize-init', function() {
	checkSidebarHeight();
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`)
}).trigger('resize-init');

var dateTimePickerIcons = {
    time: 'fa fa-clock',
    date: 'fa fa-calendar',
    up: 'fa fa-chevron-up',
    down: 'fa fa-chevron-down',
    previous: 'fa fa-chevron-double-left',
    next: 'fa fa-chevron-double-right',
    today: 'fa fa-crosshairs',
    clear: 'fa fa-trash',
    close: 'fa fa-times'
};


$(window).on('mousewheel', function() {
    $(window).trigger('scroll');
});

setInterval(function() {
    $.get('/lib/keepalive.php');
}, 1000 * 60 * 10);
